import './PromotionList.style';

import {PureComponent} from 'react';

import PromotionHero from 'Component/PromotionHero';

class PromotionList extends PureComponent {
    renderLoading() {
        return (
            <>
                <div block="PromotionHero" mods={{Loading: true}}/>
                <div block="PromotionHero" mods={{Loading: true}}/>
                <div block="PromotionHero" mods={{Loading: true}}/>
            </>
        );
    }

    render() {
        const {promotions, isLoading} = this.props;

        return (
            <main block="PromotionList">
                <h1>{__('Promotions')}</h1>
                {isLoading
                    ? this.renderLoading()
                    : promotions.map((promotion) => {
                        const {
                            id, slug, banner_url, enabled_in_promotion_page, featured: {
                                title, subtitle, button_text, background_color, background_image, text_color_list, background_image_mobile_featured, show_text_featured
                            }
                        } = promotion;

                        return (
                            enabled_in_promotion_page ?
                                <PromotionHero
                                    renderType='list'
                                    key={id}
                                    slug={slug}
                                    banner_url={banner_url}
                                    enabled_in_promotion_page={enabled_in_promotion_page}
                                    title={title}
                                    subtitle={subtitle}
                                    button_text={button_text}
                                    background_color={background_color}
                                    text_color={text_color_list}
                                    background_image={background_image}
                                    background_image_mobile_featured={background_image_mobile_featured}
                                    show_text_featured={show_text_featured}
                                />
                                : null
                        );
                    })}
            </main>
        );
    }
}

export default PromotionList;
